import type { ReviewsAPIResponse } from '@/scopes/products/user-reviews/infrastructure/api/reviews/types'
import type { Reviews } from '@/scopes/products/user-reviews/types'

export interface ReviewsResponseMapper {
  map: (apiResponse: ReviewsAPIResponse) => Reviews
}

export const createReviewsResponseMapper: () => ReviewsResponseMapper = () => {
  function map({ data: [data] }: ReviewsAPIResponse): Reviews {
    if (!data) {
      return { reviews: [], partyCompositionGroups: [], amount: 0 }
    }

    return {
      reviews: data.reviews.map((review) => {
        const rating = Math.round(review.rating * 10) / 10
        const amountOfDecimals = rating === 10 ? 0 : 1

        return {
          id: review.id.toString(),
          description: review.comment ?? '',
          partyCompositionDescription: review.partyCompositionId,
          partyCompositionGroupId: review.partyCompositionGroupId?.toString(),
          rating: rating.toLocaleString(undefined, {
            minimumFractionDigits: amountOfDecimals,
            maximumFractionDigits: amountOfDecimals,
          }),
          reviewLanguageCode: review.languageCode,
          userCountryCode: review.countryCode,
          scoreLabel: review.score.scoreLabel,
          userName: review.userFullName,
          date: review.date ? new Date(review.date) : new Date('1970-01-01'),
          departureDate: review.departureDate,
        }
      }),
      partyCompositionGroups: data.reviewsAmountOfTravelerTypes.map(group => ({
        groupId: group.travelerTypeId.toString(),
        name: group.travelerTypeName,
        amount: group.amount,
      })),
      amount: data.amount,
    }
  }

  return { map }
}
